import { operateHelmChart as planOperateHelmChart } from '@yam-plugin/helm-operator/handlers/helm'
import type { HelmReleaseConfig } from "@yam-plugin/helm-operator/types.d"
import type { OperateFunction } from "yam-types"
import type { Settings } from "../settings.d"
import type { RedisConfig } from "../types.d"

const DEFAULT_CHART_VERSION = '17.0.11'

const redisProvisioner: OperateFunction<RedisConfig> = async (plan, diff, settings: Settings) => {
  if (!diff.hasDiff) {
    return
  }

  diff.deletedItems.forEach(r => {
    plan.log.warn(`removing redis service is not allowed, please run 'helm uninstall ${r.name}' command manually`)
  })

  for (const redis of diff.currentItems) {
    const ns = redis.namespace || plan.data.namespace
    const resources = {
      requests: {
        cpu: redis.metadata?.minCpu || '100m',
        memory: redis.metadata?.minMemory || '128Mi'
      },
      limits: {
        cpu: redis.metadata?.maxCpu || '2',
        memory: redis.metadata?.maxMemory || '2Gi'
      }
    }

    const releaseConf: HelmReleaseConfig = {
      type: "helm",
      name: redis.name,
      chartName: "bitnami/redis",
      namespace: ns,
      wait: true,
      version: settings.defaultHelmChartVersion || DEFAULT_CHART_VERSION,
      values: plan._.merge({}, settings.chartValues, {
        auth: {
          enabled: !!settings.enableAuth
          // TODO password: when updating & auth enabled, must specify the previous password
        },
        replica: {
          replicaCount: redis.metadata?.replicaCount || 3,
          resources
        },
        master: {
          resources
        },
        metrics: {
          serviceMonitor: {
            enabled: !!settings.enableMetrics
          }
        }
      },
        redis.metadata?.architecture ? { architecture: redis.metadata.architecture } : {},
        settings.defaultRedisVersion ? { image: { tag: settings.defaultRedisVersion } } : {}
      )
    }
    await planOperateHelmChart(plan, releaseConf, false, settings.helmOperatorSettings || {})
    plan.action(async ctx => {
      ctx.log.info(`injecting REDIS_ENDPOINT info to containers env: '${redis.name}'`)
      ctx.containerEnvVariables.push({
        name: 'REDIS_ENDPOINT',
        value: `${redis.name}.${ns}:6379`,
        containers: redis.metadata?.forContainers
      })
    }, `apply-redis:${redis.name}`)
  }
}

export default redisProvisioner